const themeVuetify = {
  primary: '#1B5499',
  secondary: '#2E90C0',
  tertiary: '#82bd3d',
  accent: '#90A4AE',
  error: '#EF5350',
};

export default themeVuetify;
